module.exports = __webpack_public_path__ + "media/images/seller-guide-protecting-id-thumb-4d78f3813943cb03da59925d3e727d67.png";